<template>
  <div>
    <span class="tw-text-lg">Boletos Negociação</span>
    <div
      v-for="(invoiceDetail, index) in invoicesDetail"
      :key="index"
      :class="{ table: index === 0 }"
    >
      <header-colapse-table-negotiation
        :value="$toLocaleStringBr(invoiceDetail.finalValueInvoiceDocument)"
        :dueDate="invoiceDetail.dueDate"
        :installmentNumber="index + 1"
        :interest="$toLocaleStringBr(invoiceDetail.interest)"
        @colapse="() => toggleTable(index)"
      />
      <jt-data-table
        v-if="isOpen[index]"
        ref="jtDataTable"
        :api-mode="false"
        :data="invoicesDetail[index].invoicePaymentDetails"
        :fields="columns"
        :is-paginated="false"
      >
        <template #header="{ props }">
          <q-tr :props="props" class="table-header">
            <q-td v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-td>
            <q-td style="width: 5px"> </q-td>
          </q-tr>
        </template>
        <template #body="{ props }">
          <q-tr class="text-left">
            <q-td
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
              style="color: #333; font-size: 17px"
            >
              <span v-if="col.field == 'ref'">
                <span>
                  {{ props.row["ref"] }}
                </span>
              </span>
              <span v-if="col.field == 'due'">
                <span>
                  {{props.row["due"]}}
                </span>
              </span>
              <span v-else-if="col.field == 'value'">
                <span>
                  {{ $toLocaleStringBr(props.row["value"]) }}
                </span>
              </span>
              <span v-else-if="col.field == 'feesAfterDiscount'">
                <span>
                  {{ $toLocaleStringBr(props.row["feesAfterDiscount"]) }}
                </span>
              </span>
              <span v-else-if="col.field == 'fineAfterDiscount'">
                <span>
                  {{ $toLocaleStringBr(props.row["fineAfterDiscount"]) }}
                </span>
              </span>
              <span v-else-if="col.field == 'oldValue'">
                <span>
                  {{ $toLocaleStringBr(props.row["oldValue"]) }}
                </span>
              </span>
              <span v-else-if="col.field == 'correctionAfterDiscount'">
                <span>
                  {{ $toLocaleStringBr(props.row["correctionAfterDiscount"]) }}
                </span>
              </span>
              <span v-else-if="col.field == 'amortization'">
                <span>
                  {{ $toLocaleStringBr(props.row["amortization"]) }}
                </span>
              </span>
              <span v-else-if="col.field == 'effectivePayment'">
                <span>
                  {{ $toLocaleStringBr(props.row["effectivePayment"]) }}
                </span>
              </span>
            </q-td>
          </q-tr>
        </template>
      </jt-data-table>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtInput } from 'jtech-webcomps'
import NegotiationController from '../NegotiationController'
import HeaderColapseTableNegotiation from '../HeaderColapseTableNegotiation.vue'
import moment from 'moment'
@Component({
  name: 'InvoiceSelectedSteep',
  components: {
    JtDataTable,
    JtInput,
    HeaderColapseTableNegotiation
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class DetailInstallmentSteep extends Vue {
  negotiationController = NegotiationController.getInstance();
  moment = moment;
  isOpen = [false, false];
  columns = [
    {
      name: 'ref',
      label: this.$gettext('REF'),
      align: 'center',
      value: 'ref',
      field: 'ref'
    },
    {
      name: 'oldValue',
      align: 'center',
      label: this.$gettext('ORIGINAL_VALUE'),
      value: 'oldValue',
      field: 'oldValue',
      expandProp: true
    },
    {
      name: 'due',
      align: 'center',
      label: this.$gettext('ORIGINAL_MATURITY'),
      value: 'value',
      field: 'value',
      expandProp: true
    },
    {
      name: 'feesAfterDiscount',
      align: 'center',
      label: this.$gettext('FEES'),
      value: 'feesAfterDiscount',
      field: 'feesAfterDiscount'
    },
    {
      name: 'fineAfterDiscount',
      align: 'center',
      label: this.$gettext('FINE'),
      value: 'fineAfterDiscount',
      field: 'fineAfterDiscount'
    },
    {
      name: 'correctionAfterDiscount',
      align: 'center',
      label: this.$gettext('CORRECTION'),
      value: 'correctionAfterDiscount',
      field: 'correctionAfterDiscount'
    },
    {
      name: 'value',
      align: 'center',
      label: this.$gettext('UPDATED_VALUE'),
      value: 'value',
      field: 'value',
      expandProp: true
    },
    {
      name: 'effectivePayment',
      align: 'center',
      label: this.$gettext('DIVIDED_VALUE'),
      value: 'effectivePayment',
      field: 'effectivePayment',
      expandProp: true
    },
    {
      name: 'amortization',
      align: 'center',
      label: this.$gettext('AMORTIZATION'),
      value: 'amortization',
      field: 'amortization',
      expandProp: true
    }
  ];

  async mounted () {
    this.isOpen = this.invoicesDetail.map((_, index) => index === 0)
  }

  toggleTable (index) {
    this.$set(this.isOpen, index, !this.isOpen[index])
  }

  get invoicesDetail () {
    return this.negotiationController.getInvoicesDetail()
  }
}

export default DetailInstallmentSteep
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";
</style>
